import { MenuDownIcon } from 'assests/GmsIcons';
import React, { useContext, useEffect, } from 'react'
import { Link } from 'react-router-dom'
import { NONE, PREVIOS_PERIOD } from '../AnalyticsConstants';
import { TDateCompareToMenuProps } from '../analytics';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { AnalyticsContext } from '../Context/AnalyticsContext';

export const DateCompareToMenu = ({ analyticsPayload, setAnalyticsPayload, selectedCompareMenuItem, setSelectedCompareMenuItem }: TDateCompareToMenuProps) => {
  const context = useContext(AnalyticsContext);
  const { showMenu, ref, handleClick } = useClickOutside();

  useEffect(() => {
    const updatedState = {
      ...analyticsPayload,
      compareTo: selectedCompareMenuItem,
      applications: [],
      builder_ids: []
    };
    setAnalyticsPayload(updatedState);
  }, [selectedCompareMenuItem]);

  const onNoneSelected = () => {
    handleClick();
    setSelectedCompareMenuItem(NONE);
    resetData()
  }

  const onPreviousPeriodSelected = () => {
    handleClick();
    setSelectedCompareMenuItem(PREVIOS_PERIOD);
    resetData();
  }

  const resetData = () => {
    context.clearGraphAndMetricsData();
    context.setSelectedSubMenuItems([]);
    context.setSelectedCommendSubMenuItems([]);
    context.setMenuData(context.menuItems);
  }

  return (
    <div ref={ref} className='tw-relative tw-bg-white tw-z-40'>
      <div onClick={handleClick} className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} hover:tw-bg-[#EBECF0] tw-p-2 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
        <button className={`tw-text-sm tw-font-normal tw-text-[#6B778C]`}>Compared to <span className={`tw-text-sm tw-text-[#172B4D]`}>{selectedCompareMenuItem}</span></button>
        <MenuDownIcon />
      </div>
      {showMenu ? (
        <div className={`tw-origin-top-left tw-absolute tw-w-40 tw-mx-1 tw-my-1 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
          <div className={`tw-py-1 tw-text-left`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            <Link to="#" onClick={() => onNoneSelected()} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{NONE}</Link>
            <Link to="#" onClick={() => onPreviousPeriodSelected()} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{PREVIOS_PERIOD}</Link>
          </div>
        </div>
      ) : null}
    </div>
  );
}
